import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';


//-- Items --//

import { StageState } from '@data/store/stage/stage.reducer';
import { StageEffects } from '@data/store/stage/stage.effects';
import { reducer as stageReducer} from '@data/store/stage/stage.reducer';

//-- States --//

export interface AppState {
    stage: StageState;
}

//-- Reducers --//

import { ActionReducerMap } from '@ngrx/store';

export const reducers: ActionReducerMap<AppState> = {
    stage: stageReducer
};


@NgModule({
  imports: [
      StoreModule.forRoot(
          reducers,
          {
              runtimeChecks: {
                  strictStateImmutability: true,
                  strictActionImmutability: true,
                  strictStateSerializability: true,
                  strictActionSerializability: true,
              }
          }),
      EffectsModule.forRoot([
          StageEffects
      ]),
      StoreDevtoolsModule.instrument({
          maxAge: 25,
          //, logOnly: environment.production, // Restrict extension to log-only mode
      })
  ],
  exports: [StoreModule]
})
export class StorageModule { }
